module.exports = __webpack_public_path__ + "img/patient-info-down-new.fc0ff5a9.svg";